export default __webpack_public_path__ + "static/media/our-team-member-05.8b8086b9.jpg";